import React, { memo } from 'react';
export function HeadlinesShowcase() {
  const headlines = [{
    title: '¿Gastaste $1.200.000 ARS en un curso y aún te tiembla la mano antes de tocar una ceja?',
    reason: 'Crea una conexión instantánea con el trauma financiero del usuario y clasifica a la audiencia de inmediato.'
  }, {
    title: 'No arruines una cara para aprender: El Método del Látex de 21 días.',
    reason: "Ataca el 'miedo a la catástrofe' que es el bloqueador #1 para comprar insumos y empezar."
  }, {
    title: 'Lo que las academias no te enseñan sobre la memoria muscular.',
    reason: "Crea una brecha de curiosidad (Unique Mechanism) y posiciona al producto como la 'pieza faltante'."
  }];
  return <section className="py-16 px-6 bg-[#151210] border-t border-[#3A3330]" data-id="element-5">
      <div className="max-w-4xl mx-auto" data-id="element-6">
        <div className="text-center mb-10" data-id="element-7">
          <span className="text-xs font-bold tracking-widest text-[#C5A55A] uppercase mb-2 block" data-id="element-8">
            Estrategia de Marketing
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-[#F5F0EB]" data-id="element-9">
            Top 3 Headlines (Meta Ads)
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-10">
          {headlines.map((item, idx) => <div key={idx} className="bg-[#2A2520] p-6 rounded-lg border border-[#3A3330] flex flex-col" data-id="element-11">
              <div className="mb-4" data-id="element-12">
                <span className="inline-block w-8 h-8 rounded-full bg-[#C5A55A] text-[#1E1B19] text-center leading-8 font-bold text-sm mb-3" data-id="element-13">
                  {idx + 1}
                </span>
                <h3 className="font-serif text-lg font-bold text-[#F5F0EB] leading-tight" data-id="element-14">
                  "{item.title}"
                </h3>
              </div>
              <div className="mt-auto pt-4 border-t border-[#3A3330]" data-id="element-15">
                <p className="text-xs text-[#C5A55A] font-bold uppercase mb-1" data-id="element-16">
                  Por qué funciona:
                </p>
                <p className="text-sm text-[#A89B8C] italic" data-id="element-17">{item.reason}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}